import React from 'react';

const SendEmail = (props) => {
  const { data } = props;
  var { gate_out_time, status } = data;
  const handleEditClick = (e) => {
    e.stopPropagation();
    // props.context.onClickEmail(props);
    props.onClickEmail(props);

  };

  const iconStyle = {
   
    color: (!gate_out_time || (status === 6)) ? "#898787" : "#000000",
    backgroundColor: (!gate_out_time || (status === 6)) ? "#CDCDCD" : "#ffff00"
  };
  var is_disable = false
// if(data.tracking_type === "FTL"){
//   is_disable= ((!gate_out_time) || (data.status === 6) || (status === 4) || (status === 1))
// } else{
//   if(data.tracking_type === "PTL"){
//     is_disable = (data.consignment_status === "Cancelled" || data.consignment_status === "Booked" || data.consignment_status === "Invalid Docket" || data.consignment_status === "Delivered")
//   }
// }


  return (
    <div>
      {/* <button
        onClick={handleEditClick}
        className={"viewButton"}
        title="Share Link" */}
        {/* // style={iconStyle} 
        // disabled={(!gate_out_time) || (status === 6)}
      > */}
        {/* <i className="icofont icofont-edit"></i> */}
        {/* Share Link */}
        {is_disable ? (<img src={require("../../assets/images/share_icon_grey.png")} className="viewButton" title="Share Link"/>) : 
        (<img src={require("../../assets/images/share_icon.png")} className="viewButton"  onClick={handleEditClick} title="Share Link"/>)}
        {/* <i className="fa-solid fa-share" style={{width:"20px", height:"20px"}}></i> */}
      {/* </button> */}
    </div>
  );
};

export default SendEmail;